// extracted by mini-css-extract-plugin
export default {"formSection":"FormSection_formSection__JREa2","sectionTitle":"FormSection_sectionTitle__TEXlf"};